import { CurrencyItem } from '../models/Currency';

import { roundFloatNumber } from './roundFloatNumber';

export const convertValue = (
  oldCurrency: CurrencyItem | undefined,
  newCurrency: CurrencyItem | undefined,
  price: number
) => roundFloatNumber(((oldCurrency?.value || 1) * price) / (newCurrency?.value || 1));

export const convertValueNotRounded = (
  oldCurrency: CurrencyItem | undefined,
  newCurrency: CurrencyItem | undefined,
  price: number
) => ((oldCurrency?.value || 1) * price) / (newCurrency?.value || 1);
